<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="form">
  <ng-content></ng-content>
  <input type="hidden" />
</form>
